import { all, call, put, takeLatest } from "redux-saga/effects";
import { Action_GetDMAttributes  } from "actions/DanhMuc/DanhMucAttributes/actionTypes";
import { Index_GetDMAttributes, Index_GetDMAttributesSuccess } from "actions/DanhMuc/DanhMucAttributes";
import danhMucAttributesApi from "service/DanhMucService/DanhMucAttributesApi";
import { pushNotification } from "utils/notifications";
import { CheckTokenReload } from 'utils/utils';

function* Saga_getDMAttributes(action) {
  try {
    const response = yield call(danhMucAttributesApi.getDanhMucAttributes, action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_GetDMAttributesSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}


function* watch_getDMAttributes() {
  yield takeLatest(Action_GetDMAttributes, Saga_getDMAttributes);
}
//endregion watchAPI

export default function* sagas() {
  yield all([ watch_getDMAttributes()]);
}
